module.exports = getCanvasContext;

function getCanvasContext(type, opts) {
  if (typeof type !== 'string') {
    throw new TypeError('must specify type string');
  }

  opts = opts || {};

  if (typeof document === 'undefined' && !opts.canvas) {
    return null; // check for Node
  }

  var canvas = opts.canvas || document.createElement('canvas');

  if (typeof opts.width === 'number') {
    canvas.width = opts.width;
  }

  if (typeof opts.height === 'number') {
    canvas.height = opts.height;
  }

  var attribs = opts;
  var gl;

  try {
    var names = [type]; // prefix GL contexts

    if (type.indexOf('webgl') === 0) {
      names.push('experimental-' + type);
    }

    for (var i = 0; i < names.length; i++) {
      gl = canvas.getContext(names[i], attribs);
      if (gl) return gl;
    }
  } catch (e) {
    gl = null;
  }

  return gl || null; // ensure null on fail
}